import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";
import CommonTable from "../component/CommonTable";

export default function WithdrawWallet() {
  return (
    <>
      <div id="layout-wrapper">
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              {/* start page title */}
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h2 className="fw-700 mb-sm-0">Withdraw</h2>
                  </div>
                </div>
              </div>
              {/* end page title */}
              <div className="row justify-content-center">
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="">
                        <ul
                          className="nav nav-pills bg-light rounded transfer_tab"
                          role="tablist"
                        >
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              data-bs-toggle="tab"
                              href="#transfer_details"
                              role="tab"
                            >
                              Transfer Details
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-bs-toggle="tab"
                              href="#confirm_Transfer"
                              role="tab"
                            >
                              Confirm Transfer
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="tab-content mt-4">
                        <div
                          className="tab-pane active"
                          id="transfer_details"
                          role="tabpanel"
                        >
                          <div className="row">
                            <div className="col-12 mb-3">
                              <div className="hstack justify-content-between gap-2 flex-wrap">
                                <img
                                  src="assets/images/deposit/wallet.svg"
                                  alt="product-img"
                                  title="product-img"
                                  width={50}
                                />
                                <button
                                  type="Submit"
                                  className="btn btn-primary px-4"
                                >
                                  Change Payment Method
                                </button>
                              </div>
                            </div>
                            <div className="col-lg-12 mb-4">
                              <div className="d-flex gap-3 align-items-center flex-wrap">
                                <div className="text-primary">
                                  <h4 className="card-title mb-0">
                                    Payment Process{" "}
                                    <span className="text-danger">*</span>
                                  </h4>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name=""
                                    id="inlineRadio2"
                                    defaultValue="option2"
                                    defaultChecked=""
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="inlineRadio2"
                                  >
                                    Account
                                  </label>
                                </div>
                                <div className="text-primary">
                                  <h4 className="card-title mb-0">
                                    Currency
                                    <span className="text-danger">*</span>
                                  </h4>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name=""
                                    id="inlineRadio2"
                                    defaultValue="option2"
                                    defaultChecked=""
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="inlineRadio2"
                                  >
                                    USD
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="col-xl-6 col-lg-12 mb-3">
                              <div>
                                <label className="form-label">
                                  Payment Method
                                  <span className="text-danger">*</span>
                                </label>
                                <select className="form-select" name="select">
                                  <option value="Tether USD (USDT TRC20)" className="notranslate" translate="no">
                                    Tether USD (USDT TRC20)
                                  </option>
                                  <option value="Wallet" selected="">
                                    Wallet
                                  </option>
                                </select>
                              </div>
                            </div>
                            {/* <div className="col-xl-12 mb-4">
                              <div className="d-flex gap-3 align-items-center">

                              </div>
                            </div> */}
                            <div className="col-xl-6 mb-3">
                              <div>
                                <label className="form-label">
                                  Account<span className="text-danger">*</span>
                                </label>
                                <select className="form-select" name="select">
                                  <option value="91020(USD)">91020</option>
                                  <option value="91020(USD)">91020</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-xl-6 mb-3">
                              <div>
                                <label className="form-label">
                                  Amount (In USD)
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  id="example-date-input"
                                  placeholder="Amount (In USD)"
                                />
                              </div>
                            </div>
                            <div className="col-12 mb-3">
                              <button
                                type="Submit"
                                className="btn btn-primary px-4"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane"
                          id="confirm_Transfer"
                          role="tabpanel"
                        >
                          <div className="row">
                            <div className="col-xl-6">
                              <h4 className="card-title mb-4">
                                Other Details
                              </h4>
                              <div className="card p-3">
                                <h4 className="card-title text-primary pb-2 border-bottom">
                                  Terms &amp; Condition
                                </h4>
                                <h6>N/A</h6>
                              </div>
                            </div>
                            <div className="col-xl-6">
                              <h4 className="card-title mb-4">
                                Transfer Details
                              </h4>
                              <div className="table-responsive">
                                <CommonTable
                                  hideHeader={true}
                                  columns={[
                                    { accessor: "label", render: (row) => <th>{row.label}</th> },
                                    { accessor: "value", className: "bg-light-subtle", render: (row) => row.value }
                                  ]}
                                  data={[
                                    { label: "Commission", value: "0" },
                                    { label: "Withdrawal Processing Time", value: "24 Hours" },
                                    { label: "Currencies", value: "USD" },
                                    { label: "Minimum Withdrawal", value: "20" },
                                    { label: "Maximum Withdrawal", value: "10000" }
                                  ]}
                                  tableClassName="table border align-middle mb-0 table-nowrap"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* container-fluid */}
          </div>

          {/* End Page-content */}
          <Footer />
        </div>
      </div>
    </>
  );
}
